import * as Sentry from '@sentry/react';

const initSentry = () => {
  const environment = import.meta.env.VITE_ENV || import.meta.env.MODE;
  const isProduction = environment === 'production';
  const isStaging = window.location.href.includes('staging');
  const isBeta =
    window.location.href.includes('beta') ||
    window.location.href.includes('preview') ||
    window.location.href.includes('modern.pitstopconnect.com');

  // Determine the actual environment for Sentry
  let sentryEnvironment = environment;
  if (isStaging) {
    sentryEnvironment = 'staging';
  } else if (isBeta) {
    sentryEnvironment = 'beta';
  }

  const dsn = import.meta.env.VITE_SENTRY_DSN || '';

  console.log('Sentry Environment:', sentryEnvironment);

  Sentry.init({
    dsn,
    environment: sentryEnvironment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Configure trace propagation targets at the root level
    tracePropagationTargets: [
      'dashboard.pitstopconnect.com',
      'staging.dashboard.pitstopconnect.com',
      'modern.pitstopconnect.com',
      /^\//,
    ],
    tracesSampleRate: isProduction ? 0.1 : 1.0,
    replaysSessionSampleRate: isProduction ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      if (event.exception && !isProduction) {
        console.error('Sentry captured exception:', hint.originalException);
      }
      return event;
    },
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      'Network request failed',
      'AbortError',
      'signal is aborted without reason',
      'The user aborted a request',
    ],
  });
};

export default initSentry;
